import { connect } from 'react-redux';
import Header from './header';

const mapState = ({ baseConfig: { location }, searchBar }) => ({
    location,
    isSearchBarOpen: searchBar.isOpen,
});

export default connect(mapState)(Header);
